export default function DoorVehicleChoice({ name, value, onChange }) {
  const selected = value === 'hired' ? 'hired' : 'own'
  return (
    <div className="mt-1 flex flex-nowrap items-center gap-3 text-xs text-secondary whitespace-nowrap">
      {[
        ['own', 'Own'],
        ['hired', 'Hired'],
      ].map(([id, label]) => (
        <label key={id} className="inline-flex items-center gap-1.5 cursor-pointer">
          <input
            type="radio"
            name={name}
            value={id}
            checked={selected === id}
            onChange={onChange}
          />
          {label}
        </label>
      ))}
    </div>
  )
}
